import { render, staticRenderFns } from "./usage.vue?vue&type=template&id=271b85f3&"
import script from "./usage.vue?vue&type=script&lang=js&"
export * from "./usage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports